import { BaseModel } from '../base-model';
import { IAppointmentStatus } from './appointment-status.model';
import { IAppointmentType } from '.';
import { IAppointmentHistory } from './appointment-history.model';
import { IAppointmentComment } from './appointment-comment.model';
import { IAppointmentProperty } from './appointment-property.model';
import { IAppointmentPerSon } from './appointment-person.model';
import { IAppointmentOwner } from './appointment-owner.model';
import { IRecurrencePatternObject } from './appointment-recurrence-pattern.model';
import {IAppointmentPriceEstimate} from "./appointment-price-estimate.model";


export interface IAppointmentModel {
  Alarm?: boolean;
  AlarmDuration?: number;
  AppointmentLayout?: string;
  AppointmentPlace?: string;
  AppointmentStatusId?: number;
  AppointmentStatusInfo?: IAppointmentStatus;
  AppointmentTypeId?: number;
  AppointmentTypeInfo?: IAppointmentType;
  CombineSubject?: string;
  CreatedUser?: number;
    Description?: string;
    DateModify?: string;
  EndTime?: string;
  EntryId?: string;
  EntryID?: string;
  ExchangeItemId?: string;
  ExchangeItemID?: string;
  ExcludeFromReport?: boolean;
  Histories?: IAppointmentHistory[];
  Id?: number;
  InternalComments?: string;
  IsException?: boolean;
  IsRecurrence?: boolean;
  JanusRecurrencePatternXml?: string;
  Latitude?: number;
  ListOfComment?: IAppointmentComment[];
  ListOfPerson?: IAppointmentPerSon[];
  ListOfPersonId?: number[];
  ListOfProperty?: IAppointmentProperty[];
  ListOfPropertyId?: number[];
  ListOfUserId?: number[];
  ListOfUsers?: IAppointmentOwner[];
  Longitude?: number;
  MasterId?: number;
  OutlookStatus?: string;
  RecurrencePattern?: string;
  RecurrencePatternObject?: IRecurrencePatternObject;
  StartTime?: string;
  Subject?: string;
  UserIds?: string;
  Duration?: number;
  DefaultSlotDuration?: number;
  PriceEstimates?: IAppointmentPriceEstimate[];
  IsOnly?: boolean;
    IsFromTask?: boolean;
    CheckingConfictData?: string;
}
export class Appointment extends BaseModel<IAppointmentModel> implements IAppointmentModel {
  Alarm?: boolean;
  AlarmDuration?: number;
  AppointmentLayout?: string;
  AppointmentPlace?: string;
  AppointmentStatusId?: number;
  AppointmentStatusInfo?: IAppointmentStatus;
  AppointmentTypeId?: number;
  AppointmentTypeInfo?: IAppointmentType;
  CombineSubject?: string;
  CreatedUser?: number;
  Description?: string;
  EndTime?: string;
  EntryId?: string;
  EntryID?: string;
  ExchangeItemId?: string;
  ExchangeItemID?: string;
  ExcludeFromReport?: boolean;
  Histories?: IAppointmentHistory[];
  Id?: number;
  InternalComments?: string;
  IsException?: boolean;
  IsRecurrence?: boolean;
  JanusRecurrencePatternXml?: string;
  Latitude?: number;
  ListOfComment?: IAppointmentComment[];
  ListOfPerson?: IAppointmentPerSon[];
  ListOfPersonId?: number[];
  ListOfProperty?: IAppointmentProperty[];
  ListOfPropertyId?: number[];
  ListOfUserId?: number[];
  ListOfUsers?: IAppointmentOwner[];
  Longitude?: number;
  MasterId?: number;
  OutlookStatus?: string;
  RecurrencePattern?: string;
  RecurrencePatternObject?: IRecurrencePatternObject;
  StartTime?: string;
  Subject?: string;
  UserIds?: string;
  Duration?: number;
  DefaultSlotDuration?: number;
  PriceEstimates?: IAppointmentPriceEstimate[];
  IsOnly?: boolean;
  IsFromTask?: boolean;
  /**
   *
   */
  constructor(options?: IAppointmentModel) {
    super(options);
  }
}

interface PrefetchDataAppointment {
    Id: number;
    StartTime: string;
    EndTime: string;
    ShortNames: string;
    UserIds: string;
    TreatAsCancelled: boolean;
    IsRecurrence: boolean;
    IsException: boolean;
    AppointmentType: number;
    AppointmentTypeColor: number;
    AppointmentStatusId: number;
}
export interface IAgendaPrefetchInfoDetail {
    Id: number;
    FutureAppointments: PrefetchDataAppointment[];
    ManagerId: number;
    Info: {
        Reference: string,
        VisitingHours?: string
    },
    AddManagerToAgenda?: number;
}

export interface IAgendaPrefetchInfo {
    propertyInfo?: IAgendaPrefetchInfoDetail;
    personInfo?: IAgendaPrefetchInfoDetail;
}

export class AgendPrefetchInfo implements IAgendaPrefetchInfo {
    propertyInfo?: IAgendaPrefetchInfoDetail;
    personInfo?: IAgendaPrefetchInfoDetail;
    managerInfo?: {
        config?: number,
        personManager?: number,
        propertyManager?: number
    }
    constructor(props?: IAgendaPrefetchInfo) {

    }
}